import Helper from "./Helper";

class Menu {
  constructor(config = {}) {
    this.body = document.querySelector("body");
    this.hamburgerToggler = document.querySelector('.hamburger');
    this.mobileMenu = document.querySelector('.header__right');
    this.submenuToggler = document.querySelectorAll('.meta-menu__item--has-children > a');
    this.subTogglerArray = Array.prototype.slice.call(this.submenuToggler);
    this.searchToggler = document.querySelector('.meta__link--search');
    this.searchContainer = document.querySelectorAll('.search-form');
    this.searchContainerArray = document.querySelectorAll('.search-form');
    this.closeToggler = document.querySelectorAll('.menu__close');
    this.closeArray = Array.prototype.slice.call(this.closeToggler);
    this.back = document.querySelectorAll('.menu__back');
    this.backArray = Array.prototype.slice.call(this.back);
    this.submenuSelector = '.menu__wrap--level-1';
    this.metaNav = document.querySelector('.js-nav-toggler');
    this.metaNavDesktop = document.querySelector('.meta-navigation--desktop .menu__wrap--level-1')

    this.submenuOpen = false;
    this.metaNavOpen = false;
    this.searchOpen = false;


    this.bindEvents();
  }

  bindEvents() {
    this.hamburgerToggler.addEventListener("click", (e) => {
      this.toggleMobileMenu();
    });

    this.metaNav.addEventListener( "click", (e) => {
      this.closeAllSubmenus();
      this.toggleMetaNav();
    });

    
    this.searchToggler.addEventListener("click", (e) => {
      this.killMenu();
      this.toggleSearch();
    });
    
    this.subTogglerArray.forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        e.preventDefault();
        const parent = toggle.parentNode;
        if(parent.classList.contains('open')){
          parent.classList.remove('open');
        } else{
          parent.classList.add('open');
        }
      });
    });
    
    this.closeArray.forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        e.preventDefault();
        this.closeAllSubmenus();
        Helper.removeClass(this.body, "meta-nav-is-open");
      });
    });
    
    this.backArray.forEach((toggle) => {
      toggle.addEventListener("click", (e) => {
        e.preventDefault();
        this.killMenu();
      });
    });
    
    this.openMetaItemActive();
    document.onkeydown = (evt) => {
      evt = evt || window.event;
      var isEscape = false;
      if ("key" in evt) {
        isEscape = evt.key === "Escape" || evt.key === "Esc";
      } else {
        isEscape = evt.keyCode === 27;
      }
      if (isEscape) {
        this.closeAllSubmenus();
        this.menuOpen = true;
        this.closeAllSubmenus();
        Helper.removeClass(this.body, "meta-nav-is-open");
        Helper.removeClass(this.body, "submenu-is-open");
        Helper.removeClass(this.body, "menu-open");
      }
    };
  }

  openMetaItemActive() {
    document.querySelectorAll('.meta-menu__item--ancestor-active').forEach(item => item.classList.add('open'))
  }

  killMenu() {
    Helper.removeClass(this.body, "submenu-is-open");
    this.closeAllSubmenus();
  }

  closeAllSubmenus() {
    const submenus = Array.prototype.slice.call(
      document.querySelectorAll(this.submenuSelector)
    );
    Helper.removeClass(this.body, "submenu-is-open");
    submenus.forEach((submenu) => {
      Helper.removeClass(submenu, 'open');
      Helper.removeClass(submenu.parentElement, "submenu-open");
    });
    if (document.querySelector(".header-backdrop")) {
      document.querySelector(".header-backdrop").remove();
    }

    this.submenuOpen = false;
  }

  toggleMobileMenu() {
    Helper.toggleClass(this.hamburgerToggler, 'active');
    Helper.toggleClass(this.mobileMenu, 'open');
  }



  toggleMetaNav() {
    if (this.metaNavOpen) {
      Helper.removeClass(this.metaNavDesktop, 'open');
      Helper.removeClass(this.body, "meta-nav-is-open");
      if (document.querySelector(".header-backdrop")) {
        document.querySelector(".header-backdrop").remove();
      }
      this.metaNavOpen = false;
    } else {
      Helper.addClass(this.metaNavDesktop, 'open');
      Helper.addClass(this.body, "meta-nav-is-open");
      if (!document.querySelector(".header-backdrop")) {
        let backdrop = document.createElement("div");
        Helper.addClass(backdrop, "header-backdrop");
        this.body.appendChild(backdrop);
        backdrop.addEventListener("click", () => {
          Helper.removeClass(this.body, "meta-nav-is-open");
          this.closeAllSubmenus();
        });
      }
      this.metaNavOpen = true;
    }
  }

  toggleSearch() {
    Helper.toggleClass(this.searchToggler, 'active')

    this.searchContainerArray.forEach((toggler) =>{
      Helper.toggleClass(toggler, 'active');
    });
    this.searchOpen = !this.searchOpen;
    if(this.searchOpen == true){
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
      if(Helper.isDesktop()){
        document.querySelector('.search-form--desktop .form__input--search').focus();
      } else{
        document.querySelector('.search-form--mobile .form__input--search').focus();
      }
    }
  }

  killSearch() {
    Helper.removeClass(this.searchToggler, 'active')
    this.searchContainerArray.forEach((toggler) =>{
      Helper.removeClass(toggler, 'active')
    });
    this.searchOpen = false;
  }

}

export default Menu;
